/**
 * @providesModule OrientationTransitionController
 */

import {SKZConstants} from '@sdk-mobile';

const OrientationTransitionController = {
  isLandscapeGame: () => false,
  updateOrientationToLandscape: async () => {
    console.log('WebSDK: OrientationTransitionController.updateOrientationToLandscape() MOCK USED');
  },
  applyOrientationTransitionOverlay: (displayScreen: React.ReactNode) => {
    return displayScreen;
  },
  getPreviousOrientation: () => {
    console.log('WebSDK: OrientationTransitionController.getPreviousOrientation() MOCK USED');
    return SKZConstants.SKZ_PORTRAIT;
  },
  updateOrientationToPortrait: () => {
    console.log('WebSDK: OrientationTransitionController.updateOrientationToPortrait() MOCK USED');
  },
  getCurrentOrientation: () => {
    console.log('WebSDK: OrientationTransitionController.getCurrentOrientation() MOCK USED');
    return SKZConstants.SKZ_PORTRAIT;
  },
};

export default OrientationTransitionController;
